<svg
  (mouseenter)="mouseEnter()"
  (mouseleave)="mouseLeave()"
  [attr.height]="height"
  [attr.width]="width"
  [class.cursor-pointer]="isButton"
  fill="none"
  viewBox="0 0 16 12"
>
  <path
    [attr.fill]="color"
    d="M0 0V12H16V0H0ZM14.3453 1.33333L8 6.47533L1.65467 1.33333H14.3453ZM1.33333 10.6667V2.78867L8 8.19133L14.6667 2.78867V10.6667H1.33333Z"
  />
</svg>
